import React, { FunctionComponent, ReactNode } from 'react'
import { StyleProp, ViewStyle } from 'react-native'

import { CSSObject } from 'styled-components'
import styled from 'styled-components/native'

import { ThemeType } from '../../utils'

const Container = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  paddingHorizontal: '16px',
  ...(theme.breakpoints.isMinWidthLaptop && {
    paddingHorizontal: '64px',
  }),
}))

const Content = styled.View<{ theme: ThemeType; customStyling?: CSSObject }>(({ theme, customStyling = {} }) => ({
  width: '100%',
  marginHorizontal: 'auto',
  ...(theme.breakpoints.isMinWidthLaptop && {
    maxWidth: '944px',
  }),
  ...customStyling,
}))

export const ContentContainer: FunctionComponent<ContentContainerProps> = ({ style, children, customStyles }) => {
  return (
    <Container style={style}>
      <Content customStyling={customStyles?.content}>{children}</Content>
    </Container>
  )
}

type ContentContainerProps = {
  children: ReactNode | ReactNode[]
  style?: StyleProp<ViewStyle>
  customStyles?: {
    content?: CSSObject
  }
}
